import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';
import { AgentAssessment } from '../../models/agent-assessment';

export const getAiAssessment: (
  fetchContext: FetchContext,
  awardId: number,
  nominationId: number,
  accessToken?: string,
) => Promise<AgentAssessment[]> = (fetchContext, awardId, nominationId, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/staff/awards/${awardId}/nominations/${nominationId}/ai-assessment`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
  .then((response) => responseErrorHandler<AgentAssessment[]>(fetchContext.errorStore, response, 'get AI assessment'));
